<div class="op-back-button op-body-1-bold-font">
	<a mat-flat-button color="link-no-dec" id="{{ id + '_back_btn' }}" (click)="goBack()" [opTagClick]="id">
		<mat-icon svgIcon="op-caretLeft"></mat-icon>
		<span [ngClass]="green ? 'op-green' : 'op-black'">
			<ng-content></ng-content>
		</span>
	</a>
</div>
